module.exports = __webpack_public_path__ + "img/sinImagenes2.2287edb0.webp";